import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  CardContent,
  Stack,
  Card,
  Typography,
  TextField,
  Grid,
  Box,
  Divider,
  Tooltip,
} from "@mui/material";
import "./style.css";
import {
  useLocation
} from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import { useLoader } from "../../../pages/LoaderContext";
import ValidationModal from "../common/ValidationModal";
import { useForm } from "react-hook-form";
import { useProjectApiClient } from "../../Services/api/projectService";

import { successToast, errorToast } from "../../utils/toast";
import UnSavedModal from "../../components/common/UnSavedModal";
import { useAppContext } from "../../../hooks/context/AppContext";
import AutoSaveModal from "../common/AutoSaveModal";
import useIdle from "../../../hooks/useIdle";
import { useCMOInnovationForumApiClient } from "../../Services/api/CMOInnovationForumService";
import { projectVersion } from "config/navConfig";
import { relative } from "path";
import { BorderRight } from "@mui/icons-material";
import FileUpload from "../common/FileUpload";
import UploadList from "../common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";


const useStyles = makeStyles({
  themeButton: {
    backgroundColor: "#2a3fbf !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": { backgroundColor: "#2a3fbf !important" },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: "#d9d9d9 !important",
      color: "#626262 !important",
    },
  },
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const phaseSchema = yup.object().shape({
  start: yup.string().nullable().default(""),
  dev: yup.string().nullable().default(""),
  launch: yup.string().nullable().default(""),
  adhoc: yup.string().nullable().default(""),
});
const schema = yup.object().shape({
  nwFeasibility: phaseSchema,
  bcRisk: phaseSchema,
  scRisk: phaseSchema,
  comments: phaseSchema,
  outcome: phaseSchema,
});
const mapApiToForm = (apiData: any) => {
  return {
    nwFeasibility: {
      start: apiData.NWfeasibility_Start ?? "",
      dev: apiData.NWfeasibility_Dev ?? "",
      launch: apiData.NWfeasibility_Launch ?? "",
      adhoc: apiData.NWfeasibility_Adhoc ?? "",
    },
    bcRisk: {
      start: apiData.BCRisk_Start ?? "",
      dev: apiData.BCRisk_Dev ?? "",
      launch: apiData.BCRisk_Launch ?? "",
      adhoc: apiData.BCRisk_Adhoc ?? "",
    },
    scRisk: {
      start: apiData.SCRisk_Start ?? "",
      dev: apiData.SCRisk_Dev ?? "",
      launch: apiData.SCRisk_Launch ?? "",
      adhoc: apiData.SCRisk_Adhoc ?? "",
    },
    comments: {
      start: apiData.OtherComments_Start ?? "",
      dev: apiData.OtherComments_Dev ?? "",
      launch: apiData.OtherComments_Launch ?? "",
      adhoc: apiData.OtherComments_Adhoc ?? "",
    },
    outcome: {
      start: apiData.IfOutcome_Start ?? "",
      dev: apiData.IfOutcome_Dev ?? "",
      launch: apiData.IfOutcome_Launch ?? "",
      adhoc: apiData.IfOutcome_Adhoc ?? "",
    },
  };
};

const CMOInnovationForumForm: React.FC = () => {
  const location = useLocation();
  const { projectId, projectKey } = useParams<{
    projectKey: string;
    projectId: string;
  }>();
  const { getProjectDetails, getRequiredField, publishProjectOnSave, uploadProjectFile } =
    useProjectApiClient();
  //  API Client for Technical Scopes
  const {
    createCMOInnovationForum,
    updateCMOInnovationForum,
    getCMOInnovationForumById,
  } = useCMOInnovationForumApiClient();

  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const [isDisabled, setIsDisabled] = useState(true);
  const { setLoading } = useLoader();
  const [validationErrors, setValidationErrors] = useState({});
  const [isValidationError, setIsValidationError] = useState(false);
  const [projectDetails, setProjectDetails] = useState({ issaved: false });
  const [isExisting, setIsExisting] = useState(false);
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10);
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  type SectionFields = {
    start: string;
    dev: string;
    launch: string;
    adhoc: string;
  };

  interface ProjectFormData {
    nwFeasibility: SectionFields;
    bcRisk: SectionFields;
    scRisk: SectionFields;
    comments: SectionFields;
    outcome: SectionFields;
  }
  const [formData, setFormData] = useState<ProjectFormData>({
    nwFeasibility: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    bcRisk: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    scRisk: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    comments: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    outcome: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
  });
  const [initialformData, setInitialFormData] = useState({
    nwFeasibility: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    bcRisk: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    scRisk: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    comments: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
    outcome: {
      start: "",
      dev: "",
      launch: "",
      adhoc: "",
    },
  });
  const { handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  //  Fetch Risks
  useEffect(() => {
    setLoading(true);
    const fetchOptions = async () => {
      await Promise.all([fetchsProjectDetails()]);
    };
    fetchOptions();
    fetchCMOInnovationForum();
  }, []);

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit);
    }
  }, [userData]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);

  useEffect(() => {
    let check = JSON.stringify(formData) === JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }
  }, [formData]);

  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved });
        setIsDraftDisabled(data.issaved);
      }
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };
  const isEmptyObject = (obj: object) => {
    return JSON.stringify(obj) === "{}";
  };
  const fetchCMOInnovationForum = async () => {
    try {
      const response = await getCMOInnovationForumById(projectKey);
      setLoading(false);
      if (!isEmptyObject(response.data)) {
        setIsExisting(true);
        const mapped = mapApiToForm(response.data);
        setFormData(mapped);
        setInitialFormData(mapped);
      }
    } catch (error) {
      console.error(" Failed to fetch Technical Scope data:", error);
    }
  };

  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey);
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved);
    }
  };

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };

  const toNullIfEmpty = (value: any) =>
    value === "null" ||
      value === "undefined" ||
      value === undefined ||
      value === ""
      ? null
      : value;

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data;
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const getCompleteAuditTrail = (
    initialData: Record<string, any>,
    updatedData: Record<string, any>
  ): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === "project_id") continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue),
      });
    }
    return audit;
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  const onSubmit = async (data: any, type: boolean, url: string) => {
    try {
      // 1. Check required fields from API
      if (type) {
        const resField = await fetchRequiredField();
        if (resField?.data && resField?.data.length) {
          const groupedErrors = groupByModule(resField.data);
          setValidationErrors(groupedErrors);
          setIsValidationError(true);
          return;
        }
      }
      setLoading(true);
      const payload = {
        Project_Key: projectKey,
        NWfeasibility_Start: toNullIfEmpty(formData.nwFeasibility.start),
        NWfeasibility_Dev: toNullIfEmpty(formData.nwFeasibility.dev),
        NWfeasibility_Launch: toNullIfEmpty(formData.nwFeasibility.launch),
        NWfeasibility_Adhoc: toNullIfEmpty(formData.nwFeasibility.adhoc),
        BCRisk_Start: toNullIfEmpty(formData.bcRisk.start),
        BCRisk_Dev: toNullIfEmpty(formData.bcRisk.dev),
        BCRisk_Launch: toNullIfEmpty(formData.bcRisk.launch),
        BCRisk_Adhoc: toNullIfEmpty(formData.bcRisk.adhoc),
        SCRisk_Start: toNullIfEmpty(formData.scRisk.start),
        SCRisk_Dev: toNullIfEmpty(formData.scRisk.dev),
        SCRisk_Launch: toNullIfEmpty(formData.scRisk.launch),
        SCRisk_Adhoc: toNullIfEmpty(formData.scRisk.adhoc),
        OtherComments_Start: toNullIfEmpty(formData.comments.start),
        OtherComments_Dev: toNullIfEmpty(formData.comments.dev),
        OtherComments_Launch: toNullIfEmpty(formData.comments.launch),
        OtherComments_Adhoc: toNullIfEmpty(formData.comments.adhoc),
        IfOutcome_Start: toNullIfEmpty(formData.outcome.start),
        IfOutcome_Dev: toNullIfEmpty(formData.outcome.dev),
        IfOutcome_Launch: toNullIfEmpty(formData.outcome.launch),
        IfOutcome_Adhoc: toNullIfEmpty(formData.outcome.adhoc),
      };
      const initialPayload = {
        Project_Key: projectKey,
        NWfeasibility_Start: toNullIfEmpty(initialformData.nwFeasibility.start),
        NWfeasibility_Dev: toNullIfEmpty(initialformData.nwFeasibility.dev),
        NWfeasibility_Launch: toNullIfEmpty(
          initialformData.nwFeasibility.launch
        ),
        NWfeasibility_Adhoc: toNullIfEmpty(initialformData.nwFeasibility.adhoc),
        BCRisk_Start: toNullIfEmpty(initialformData.bcRisk.start),
        BCRisk_Dev: toNullIfEmpty(initialformData.bcRisk.dev),
        BCRisk_Launch: toNullIfEmpty(initialformData.bcRisk.launch),
        BCRisk_Adhoc: toNullIfEmpty(initialformData.bcRisk.adhoc),
        SCRisk_Start: toNullIfEmpty(initialformData.scRisk.start),
        SCRisk_Dev: toNullIfEmpty(initialformData.scRisk.dev),
        SCRisk_Launch: toNullIfEmpty(initialformData.scRisk.launch),
        SCRisk_Adhoc: toNullIfEmpty(initialformData.scRisk.adhoc),
        OtherComments_Start: toNullIfEmpty(initialformData.comments.start),
        OtherComments_Dev: toNullIfEmpty(initialformData.comments.dev),
        OtherComments_Launch: toNullIfEmpty(initialformData.comments.launch),
        OtherComments_Adhoc: toNullIfEmpty(initialformData.comments.adhoc),
        IfOutcome_Start: toNullIfEmpty(initialformData.outcome.start),
        IfOutcome_Dev: toNullIfEmpty(initialformData.outcome.dev),
        IfOutcome_Launch: toNullIfEmpty(initialformData.outcome.launch),
        IfOutcome_Adhoc: toNullIfEmpty(initialformData.outcome.adhoc),
      };
      const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
      {
        /* @ts-ignore */
      }
      const res = !isExisting
        ? // @ts-ignore
        await createCMOInnovationForum(payload, projectKey)
        : await updateCMOInnovationForum(payload, projectKey);
      if (type === true) {
        await pubLishProjectData();
        setProjectDetails({ issaved: type });
        setIsDraftDisabled(type);
      }
      if (res) {
        fetchCMOInnovationForum();
        updateAppData({
          isFormChanged: false,
          showUnSavedModal: false,
          url: appData.url,
        });
        if (!isExisting) {
          setIsExisting(true);
        }
        setLoading(false);
        successToast(res.message);
        setTimeout(() => {
          navigate(
            url
              ? url
              : `${projectVersion}/project/cmoinnovationforum/${projectId}/${projectKey}`
          );
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: "" });
  };

  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)();
  };

  let draftSavedModal = () => {
    updateAppData({
      isFormChanged: false,
      showUnSavedModal: false,
      url: appData.url,
    });
    handleFormSubmit(false, appData.url)();
  };

  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({
      isFormChanged: false,
      showUnSavedModal: false,
      url: appData.url,
    });
    navigate(appData.url);
  };

  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }
  };

  let closeValidationModal = () => {
    setIsValidationError(false);
    setValidationErrors({});
  };

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField();
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, "")();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, "")();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false);
  };

  const handleChange = (
    section: keyof ProjectFormData,
    column: "start" | "dev" | "launch" | "adhoc",
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...(prev[section] as Record<string, string>),
        [column]: value,
      },
    }));
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 11, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };


  return (
    <>

      <div className="create-cmoinnovationform-content">
        <ToastContainer />
        <Card className="" sx={{ padding: "10px", marginTop: "-15px" }}>
          <CardContent>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 2 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button
                      disabled={isDisabled}
                      onClick={handleFormSubmit(true, "")}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: "white !important",
                        backgroundColor: `${isDisabled ? "#d9d9d9 !important" : "#2a3fbf !important"
                          }`,
                      }}
                      className={classes.themeButton}
                    >
                      Submit
                    </Button>
                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={handleFormSubmit(false, "")}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: "white !important",
                        backgroundColor: "#2a3fbf !important",
                        "&.Mui-disabled": {
                          backgroundColor: "#d9d9d9 !important",
                          color: "#5f6368 !important",
                        },
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button
                      disabled={isDisabled}
                      onClick={handleCancel}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                      }}
                      className={classes.cancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>

              }

            </div>
            {
              isUpload ?
                <>
                  {/* @ts-ignore */}
                  <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={11}></UploadList>
                </>

                :
                <form noValidate>
                  {/* Column Headers */}
                  {/* <Grid
                container
                sx={{
                  // bgcolor: "#E4E9F1",
                  p: 1,
                  mb: 2,
                }}
              >
               
               

                <Grid item xs={3} bgcolor="#f3f7eb">
                  <Typography align="center" fontSize="14px" fontWeight="bold">
                    Start
                  </Typography>
                </Grid>
                <Grid item xs={3} bgcolor="#f0ecf4">
                  <Typography align="center" fontSize="14px" fontWeight="bold">
                    Dev
                  </Typography>
                </Grid>
                <Grid item xs={3} bgcolor="#dde8f6">
                  <Typography align="center" fontSize="14px" fontWeight="bold">
                    Launch
                  </Typography>
                </Grid>
                {/* If you want AD-HOC as the 4th column instead of Launch alone */}
                  {/* <Grid item xs={3} bgcolor="#f7eae9">
                  <Typography align="center" fontSize="14px" fontWeight="bold">
                    AD-HOC
                  </Typography>
                </Grid>
              </Grid> */}
                  {/* <div className="button-top-form"></div>  */}
                  <Grid container sx={{ p: 1, mb: 2, mt: 2 }} borderRadius="10px" border="2px solid #2A3FBF" bgcolor="#f5f5f5">
                    <br></br>
                    <br></br>
                    <br></br>
                    <Divider sx={{ my: 2 }}>
                      <Typography
                        sx={{ color: "#191cd2ff", fontWeight: "bold", fontSize: "16px" }}
                      >
                        IF Key Info
                      </Typography>
                    </Divider>
                    <Grid item xs={12} className="column-backgrounds">

                      {/* NW Feasibility */}
                      <Box sx={{ mb: 2, pb: 2 }} position="relative">
                        {/* <div className="column1-bgcolor">
                  </div> */}

                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <div>
                              <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#ebf1dd" padding="5px">
                                Start
                              </Typography>
                            </div>
                            <br></br>
                            <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                              NW Feasibility
                            </Typography>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.nwFeasibility.start}
                              onChange={(e) =>
                                handleChange("nwFeasibility", "start", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <div>

                              <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#e5e0ec" padding="5px">
                                Develop
                              </Typography>
                              <br></br>
                              <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                                &nbsp;
                              </Typography>
                            </div>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.nwFeasibility.dev}
                              onChange={(e) =>
                                handleChange("nwFeasibility", "dev", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <div>
                              <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#c6d9f0" padding="5px">
                                Launch
                              </Typography>
                              <br></br>
                              <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                                &nbsp;
                              </Typography>
                            </div>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.nwFeasibility.launch}
                              onChange={(e) =>
                                handleChange("nwFeasibility", "launch", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <div>
                              <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#f2dcdb" padding="5px">
                                AD-HOC
                              </Typography>
                              <br></br>
                              <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                                &nbsp;
                              </Typography>
                            </div>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.nwFeasibility.adhoc}
                              onChange={(e) =>
                                handleChange("nwFeasibility", "adhoc", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* BC Risk */}
                      <Box sx={{ mb: 2, pb: 2 }}>
                        <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                          BC Risk
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.bcRisk.start}
                              onChange={(e) =>
                                handleChange("bcRisk", "start", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.bcRisk.dev}
                              onChange={(e) =>
                                handleChange("bcRisk", "dev", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.bcRisk.launch}
                              onChange={(e) =>
                                handleChange("bcRisk", "launch", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              fullWidth
                              disabled={isDisabled}
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.bcRisk.adhoc}
                              onChange={(e) =>
                                handleChange("bcRisk", "adhoc", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* SC Risks */}
                      <Box sx={{ mb: 2, pb: 2 }}>
                        <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                          SC Risks
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.scRisk.start}
                              onChange={(e) =>
                                handleChange("scRisk", "start", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.scRisk.dev}
                              onChange={(e) =>
                                handleChange("scRisk", "dev", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.scRisk.launch}
                              onChange={(e) =>
                                handleChange("scRisk", "launch", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.scRisk.adhoc}
                              onChange={(e) =>
                                handleChange("scRisk", "adhoc", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* Other Comments */}
                      <Box sx={{ mb: 2, pb: 2 }}>
                        <Typography fontWeight="bold" paddingLeft="10px" fontSize="12px" gutterBottom>
                          Other Comments
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.comments.start}
                              onChange={(e) =>
                                handleChange("comments", "start", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.comments.dev}
                              onChange={(e) =>
                                handleChange("comments", "dev", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.comments.launch}
                              onChange={(e) =>
                                handleChange("comments", "launch", e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextField
                              disabled={isDisabled}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              value={formData.comments.adhoc}
                              onChange={(e) =>
                                handleChange("comments", "adhoc", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>

                    </Grid>
                    <Grid item xs={3}>
                    </Grid>
                  </Grid>


                  {/* <div className="outcome-section">       */}
                  {/* IF Outcome row */}
                  {/* IF Outcome Section Header */}
                  <div>
                    {/* <Divider textAlign="center" className="vertical-display-outcome">
                  <Box
                    sx={{
                      // bgcolor: "#e0dedb", // light gray background
                      px: 2, // horizontal padding
                      py: 0.5, // vertical padding
                      // borderRadius: "2px",
                      borderRadius: "20px",
                      border: "1px solid #bfbcbc",
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight="bold" fontSize={"12px"} color="blue">
                      IF Outcome
                    </Typography>
                  </Box>
                </Divider> */}
                    <Grid container sx={{ p: 1, mb: 2, mt: 2 }} borderRadius="10px" border="2px solid #2A3FBF" bgcolor="#f5f5f5">

                      <br></br>
                      <br></br>
                      <Divider sx={{ my: 2 }}>
                        <Typography
                          sx={{ color: "#191cd2ff", fontWeight: "bold", fontSize: "16px" }}
                        >
                          IF Outcome
                        </Typography>
                      </Divider>
                      <Grid item xs={12} className="column-backgrounds">
                        {/* NW Feasibility */}
                        <Box sx={{ mb: 2, pb: 2 }} position="relative">
                          {/* <div className="column1-bgcolor">
                  </div> */}
                          <Grid container >
                            <Grid item xs={3}>
                              <div>
                                <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#ebf1dd" padding="5px">
                                  Start
                                </Typography>
                              </div>
                              <br>
                              </br>
                              <Grid item marginRight="10px" marginLeft="10px">
                                <TextField
                                  disabled={isDisabled}
                                  fullWidth
                                  multiline
                                  rows={4}
                                  variant="outlined"
                                  placeholder="EG Approved / Not Approved / Launch Delay"
                                  value={formData.outcome.start}
                                  onChange={(e) =>
                                    handleChange("outcome", "start", e.target.value)
                                  }
                                />
                              </Grid>
                            </Grid>
                            <Grid item xs={3} >
                              <div>
                                <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#e5e0ec" padding="5px">
                                  Develop
                                </Typography>
                              </div>
                              <br></br>

                              <Grid item marginRight="10px" marginLeft="10px">
                                <TextField
                                  disabled={isDisabled}
                                  fullWidth
                                  multiline
                                  rows={4}
                                  variant="outlined"
                                  placeholder="EG Approved / Not Approved / Launch Delay"
                                  value={formData.outcome.dev}
                                  onChange={(e) =>
                                    handleChange("outcome", "dev", e.target.value)
                                  }
                                />
                              </Grid>
                            </Grid>
                            <Grid item xs={3}>
                              <div>
                                <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#c6d9f0" padding="5px">
                                  Launch
                                </Typography>
                              </div>
                              <br></br>
                              <Grid item marginRight="10px" marginLeft="10px">
                                <TextField
                                  disabled={isDisabled}
                                  fullWidth
                                  multiline
                                  rows={4}
                                  variant="outlined"
                                  placeholder="EG Approved / Not Approved / Launch Delay"
                                  value={formData.outcome.launch}
                                  onChange={(e) =>
                                    handleChange("outcome", "launch", e.target.value)
                                  }
                                />
                              </Grid>
                            </Grid>
                            <Grid item xs={3}>
                              <div>
                                <Typography align="center" fontSize="14px" fontWeight="bold" bgcolor="#f2dcdb" padding="5px">
                                  AD-HOC
                                </Typography>
                              </div>
                              <br></br>
                              <Grid item marginRight="10px" marginLeft="10px">
                                <TextField
                                  disabled={isDisabled}
                                  fullWidth
                                  multiline
                                  rows={4}
                                  variant="outlined"
                                  placeholder="EG Approved / Not Approved / Launch Delay"
                                  value={formData.outcome.adhoc}
                                  onChange={(e) =>
                                    handleChange("outcome", "adhoc", e.target.value)
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </div>
                </form>
            }

          </CardContent>
        </Card>
      </div>

      {/* @ts-ignore */}
      <UnSavedModal
        close={closeUnSavedModal}
        saveUnSavedModal={saveUnSavedModal}
        draftSavedModal={draftSavedModal}
        discardModal={discardModal}
        isDraftDisabled={isDraftDisabled}
      />
      <ValidationModal
        validationErrors={validationErrors}
        open={isValidationError}
        closeValidationModal={closeValidationModal}
      />
      <AutoSaveModal
        open={autoSaveModal}
        closeAutoSave={closeAutoSave}
        autoSave={autoSave}
      ></AutoSaveModal>
    </>
  );
};

export default CMOInnovationForumForm;
